import { useQuery } from '@tanstack/react-query';

import { getTeamInviteInfo } from '../../../api/teams/getTeamInviteInfo';

export function useGetTeamInviteInfo(inviteCode: string) {
  return useQuery({
    queryKey: ['invite', inviteCode, 'info'],
    queryFn: () => getTeamInviteInfo(inviteCode),
    staleTime: 0, // Do not cache
    cacheTime: 0, // Do not cache
    retry: false, // do not retry
    enabled: !!inviteCode,
  });
}
